export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-blogger-ac1b972b03172ab3ec7e9eeeb73fcb79.svg";